import React from "react";
import { Link } from "react-router-dom";
import aboutImg from "../assets/images/privix-chatbot.jpg"
import {FiShield, FiZap, FiTrendingUp, FiGlobe} from '../assets/icons/vander'

export default function AboutThree(){
    const advantageData = [
        {
            icon: <FiShield className="h-7 w-7"/>,
            title: "Privacy First",
            desc: "Your data never leaves your premises"
        },
        {
            icon: <FiZap className="h-7 w-7"/>,
            title: "Lightning Fast",
            desc: "Local processing means minimal latency"
        },
        {
            icon: <FiTrendingUp className="h-7 w-7"/>,
            title: "Cost Effective",
            desc: "No per-token charges or hidden fees"
        },
        {
            icon: <FiGlobe className="h-7 w-7"/>,
            title: "Full Control",
            desc: "You own your AI infrastructure"
        }
    ]

    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                    <div className="relative">
                        <div className="relative overflow-hidden rounded-lg border-8 border-slate-900 dark:border-white shadow-lg dark:shadow-gray-800">
                            <img src={aboutImg} className="transform hover:scale-105 duration-500 ease-in-out" alt=""/>
                            
                            <div className="absolute bottom-0 start-0 end-0 bg-gradient-to-t from-slate-900 to-transparent p-6">
                                <div className="text-white">
                                    <h5 className="text-lg font-semibold mb-2">The Future of Enterprise AI</h5>
                                    <p className="text-slate-300 text-sm">Secure. Local. Powerful.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="overflow-hidden absolute lg:h-[400px] h-[320px] lg:w-[400px] w-[320px] bg-gradient-to-tl to-amber-400/40 from-fuchsia-600/40 bottom-0 start-0 rotate-45 -z-1 rounded-3xl"></div>
                    </div>

                    <div className="lg:ms-8">
                        <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Why Leading Organizations <br/> <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">Choose Privix.AI</span></h3>
                        
                        <p className="text-slate-400">We're revolutionizing how enterprises use AI by putting privacy and security first. Our vision is to make advanced AI accessible to every organization without compromising their data sovereignty.</p>

                        <div className="grid grid-cols-2 gap-4 mt-6">
                            {advantageData.map((item, index) => (
                                <div key={index} className="p-4 rounded-lg bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 transition-all duration-500">
                                    <div className="w-12 h-12 bg-amber-400/5 text-amber-400 rounded-lg flex items-center justify-center mb-3">
                                        {item.icon}
                                    </div>
                                    <h5 className="text-lg font-semibold mb-1">{item.title}</h5>
                                    <p className="text-slate-400 text-sm">{item.desc}</p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-8">
                            <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded-md">
                                Start Your Privacy-First AI Journey
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}